import React,{useState,useEffect} from 'react';
import LiveFunction from './LiveFunction';
import axios from 'axios';
import youtube from '../icon/icons8-youtube-96.png';
import Promote2 from '../Image/Promote2.png';


<iframe width="1236" height="695" src="https://www.youtube.com/embed/t1GodAvci_g" title="WPT Live!" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>


function Youtubelive() {
  const [targetVideoId,setTargetVideoId] = useState('');
  console.log("target Video Id:",targetVideoId);
  //get video id from php server
   function connectPhp(){
        let data =[];
        axios.get("https://www.pta-hk.com/getVideoId.php").then
        (response=>{
            console.log("Response Data:",response.data);
            data = response.data;
            setTargetVideoId(data);
            console.log(data);
        }).catch((e)=>console.log(e));
    }

    useEffect(()=>{
        connectPhp();
    },[]);

  //t1GodAvci_g
  //xZnHIuYbzeo
  return (
    <div className="container">
      <div className="container-content">
        <div className="youtube-container">
          <div className="title">Youtube 比賽直播 &nbsp;&nbsp;
          <img src={youtube}
            alt="Poker Tournament Association"
            className="icon"
            />
          </div>
          <LiveFunction videoId={targetVideoId}/>
        </div>
        
      </div>
      <div className="banner-section">
        <a
                href="https://www.pta-hk.com/#/booking" 
                target="_blank"
                rel="nopener noreferrer"
                arial-label="Event"
        >
            <img src={ Promote2 }
                alt="Poker Tournament Association"
                className="bannerImage2"
            />
        </a>
        </div>  
    </div>

    
  )
}

export default Youtubelive;

      



